<div>Name: {{ certification.name }}</div>
<div *ngIf="certification.number">Number: {{ certification.number }}</div>
<div *ngIf="certification.activeDate && certification.expirationDate; else notBothDates">
  <span>Start/End:</span>
  <span>{{ certification.activeDate | date: 'shortDate' }}-{{ certification.expirationDate | date: 'shortDate' }}</span>
</div>
<ng-template #notBothDates>
  <div *ngIf="certification.activeDate || certification.expirationDate">
    <span *ngIf="certification.activeDate">Start</span>
    <span *ngIf="certification.expirationDate">End</span>:{{ certification.activeDate | date: 'shortDate'
    }}{{ certification.expirationDate | date: 'shortDate' }}
  </div>
</ng-template>
